export const AuctionKindAscending = "Ascending";
export const AuctionKindSealed = "Sealed";
export const AuctionKindSealedFloor = "SealedFloor";
export const AuctionKindJapanese = "Japanese";

export const AuctionKindGDAContinuous = "GDAContinuous";
export const AuctionKindGDADiscrete = "GDADiscrete";
export const AuctionKindBigNumber = "BigNumber";

export type AuctionKind =
  | typeof AuctionKindAscending
  | typeof AuctionKindSealed
  | typeof AuctionKindSealedFloor
  | typeof AuctionKindGDAContinuous
  | typeof AuctionKindGDADiscrete
  | typeof AuctionKindJapanese
  | typeof AuctionKindBigNumber;

export type AuctionKindBidding =
  | typeof AuctionKindAscending
  | typeof AuctionKindSealed
  | typeof AuctionKindSealedFloor
  | typeof AuctionKindJapanese;
